export default {
  data() {
    return {
      current_step: null,
      submission_data: {},
      phone_key: 0,
      phone_mode: 'messages',
      step_config: null,
      previously_shown_message_count: 0,
    };
  },

  computed: {
    total_steps() {
      return this.step_config ? Object.keys(this.step_config.step_names).length : 0;
    },

    current_step_number() {
      if (!this.step_config) return 0;
      return this.step_config.steps.indexOf(this.current_step) + 1;
    },

    progress_percentage() {
      return this.total_steps > 0 ? (this.current_step_number / this.total_steps) * 100 : 0;
    },

    current_step_name() {
      if (!this.step_config) return '';
      return this.step_config.step_names[this.current_step] || '';
    },

    can_go_previous() {
      if (!this.step_config) return false;
      const currentIndex = this.step_config.steps.indexOf(this.current_step);
      return currentIndex > 0;
    },

    can_go_next() {
      if (!this.step_config) return false;
      const currentIndex = this.step_config.steps.indexOf(this.current_step);
      return currentIndex < this.step_config.steps.length - 1;
    },

    formatted_steps() {
      if (!this.step_config) return [];
      return this.step_config.steps.map(step_id => ({
        id: step_id,
        name: this.step_config.step_names[step_id] || step_id
      }));
    },
  },

  methods: {
    initializeSteps(stepConfig) {
      this.step_config = stepConfig;
      this.current_step = stepConfig.initial_step || stepConfig.steps[0];
      this.phone_mode = stepConfig.initial_phone_mode || 'messages';
    },

    goToPreviousStep() {
      if (!this.step_config) return;

      const currentIndex = this.step_config.steps.indexOf(this.current_step);
      if (currentIndex > 0) {
        const previousStep = this.step_config.steps[currentIndex - 1];
        this.navigateToStep(previousStep);
      }
    },

    goToNextStep() {
      if (!this.step_config) return;

      const currentIndex = this.step_config.steps.indexOf(this.current_step);
      if (currentIndex < this.step_config.steps.length - 1) {
        const nextStep = this.step_config.steps[currentIndex + 1];
        this.navigateToStep(nextStep);
      }
    },

    goToStep(step_id) {
      if (!this.step_config) return;
      if (this.step_config.steps.includes(step_id)) {
        this.navigateToStep(step_id);
      }
    },

    navigateToStep(stepId) {
      if (!this.step_config) return;

      const stepDefinition = this.step_config.step_definitions[stepId];
      if (!stepDefinition) {
        return;
      }

      // before changing step, record how many messages are currently shown
      // so the text conversation knows not to re-animate them
      if (this.conversation && Array.isArray(this.conversation)) {
        this.previously_shown_message_count = this.conversation.length;
      }

      this.current_step = stepId;

      if (stepDefinition.phone_mode) {
        this.phone_mode = stepDefinition.phone_mode;
      }

      if (stepDefinition.onEnter && typeof stepDefinition.onEnter === 'function') {
        stepDefinition.onEnter.call(this);
      }

      if (
        stepDefinition.requires_submission_data &&
        Object.keys(this.submission_data).length === 0
      ) {
        this.submission_data = stepDefinition.default_submission_data || {};
      }

      this.scrollToTop();
    },

    resetDemo() {
      if (!this.step_config) return;

      this.phone_key += 1; // force re-render of mock phone
      this.current_step = this.step_config.initial_step || this.step_config.steps[0];
      this.phone_mode = this.step_config.initial_phone_mode || 'messages';
      this.submission_data = {};
      this.previously_shown_message_count = 0;
      this.scrollToTop();
    },

    handleStepSubmission(data, targetStep) {
      this.submission_data = data;
      if (targetStep) {
        this.navigateToStep(targetStep);
      }
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
